import React, { useMemo, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useMap } from "react-leaflet";
import { Popover } from "react-tiny-popover";

export default function RoadRestrictionsList({ route, routeControlPoints }) {
    const roadRestrictions = useMemo(
        () => (route?.segments ?? []).reduce((acc, item) => [...acc, ...(item.roadRestrictions ?? [])], []),
        [route],
    );
    const map = useMap();
    const [opened, setOpened] = useState(true);

    const hasRoadRestrictions = roadRestrictions?.length > 0;
    const hasRouteControlPoints = routeControlPoints?.length > 0;

    if (!hasRoadRestrictions && !hasRouteControlPoints) {
        return null;
    }

    const showPointInMap = (point) => {
        map.setView([...point.location].reverse(), 13);
    };

    const showControlPointInMap = (item) => {
        let coords;
        if (item.geozone?.location?.coordinates) {
            coords = [...item.geozone.location.coordinates].reverse();
        } else if (item.location && Array.isArray(item.location)) {
            coords = [...item.location].reverse();
        }
        if (coords) {
            map.setView(coords, 13);
        }
    };

    const popoverContent = (
        <div className="map-control py-1 mw-350 font-size-12 map-road-restrictions lh-14">
            <div className="d-flex pb-2 px-2">
                <div className="flex-1">
                    <b>
                        Обратите внимание маршрут проходит через запрещающие знаки, при необходимости скорректируйте
                        маршрут
                    </b>
                </div>
                <div className="pl-2 cursor-pointer" onClick={() => setOpened(!opened)}>
                    <div className="font-size-10 text-muted icon-uEA07-delite" />
                </div>
            </div>
            <div>
                <Scrollbars autoHeight autoHeightMax={400}>
                    {roadRestrictions.map((item, i) => (
                        <div key={i} className="map-road-restrictions__item px-2">
                            <div className="map-road-restrictions__icon">
                                <img src={item.type.iconUrl} alt={item.type.name || ""} />
                            </div>
                            <div className="lh-14 map-road-restrictions__name">
                                <div className="link" onClick={() => showPointInMap(item)}>
                                    {item.name}
                                </div>
                                {item.description && (
                                    <small className="font-italic text-muted">{item.description}</small>
                                )}
                            </div>
                        </div>
                    ))}
                    {hasRouteControlPoints &&
                        routeControlPoints.map((item, i) => (
                            <div key={`rcp-${i}`} className="map-road-restrictions__item px-2">
                                <div className="map-road-restrictions__icon">
                                    <div className="map-bid-legend__point--route-control-point" />
                                </div>
                                <div className="lh-14 map-road-restrictions__name">
                                    <div className="link" onClick={() => showControlPointInMap(item)}>
                                        {item.name}
                                    </div>
                                    {item.comment && <small className="font-italic text-muted">{item.comment}</small>}
                                </div>
                            </div>
                        ))}
                </Scrollbars>
            </div>
        </div>
    );

    return (
        <Popover
            isOpen={opened}
            positions="left"
            align="start"
            content={popoverContent}
            parentElement={document.getElementById("modal-map") || document.getElementById("map")}
        >
            <div className="map-control">
                <div className="map-road-restrictions__btn" onClick={() => setOpened(!opened)} />
            </div>
        </Popover>
    );
}
